import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
// Components
import { ModelList } from '../../../components/PaginatedList/ModelList';

// Styles
import { HorizontalStack, SmartContainer, Stack, StyledGrid, Surface } from '../../../styles/Containers'
import { StyledB, StyledP } from '../../../styles/StyledHTML';
import { EmptyList } from '../../components/Empty/EmptyList';
import { TERM_LIBRARY, downloadFileUrl, hasAccess, useWindowSize } from '../../services/CaptureCollabService';
import { AssetCard } from './AssetCard';
import { ImageCroppingPresets, mediaPath } from '../../../modules/Media/MediaUtils';
import { TagSelector } from '../../../components/Taxonomy/TagSelector';

// REDUX
import { FullLocations } from '../Location/redux/locations.selectors';
import { FullPeople } from '../People/redux/people.selectors';
import { FullGenericTags } from '../GenericTags/redux/generictags.selectors';
import { searchGenericTags } from '../GenericTags/redux/generictags.actions';
import { forceDeleteAsset, restoreAsset, searchAssets, batchDownload } from './redux/assets.actions';
import { FullAssets } from './redux/assets.selectors';
import { searchPeople } from '../People/redux/people.actions';
import { searchLocations } from '../Location/redux/locations.actions';
import { EmptyMessage } from '../../components/Empty/EmptyMessage';
import { getQueryParam, openInNewTab, removeQueryParam, setQueryParam, useKeyPress } from '../../../services/Utils';
import { StyledCircularProgress } from '../../../styles/matieralui/Progress';
import { StyledToggleButton } from '../../../styles/matieralui/ToggleButton';
import { IconAdd, IconBack, IconClear, IconDownload, IconEdit, IconFeed, IconForward, IconGrid, IconLocation, IconPerson, IconRefresh, IconSelect, IconSelectClear, IconShare, IconTag, IconTrash, IconView, IconX } from '../../Icons';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { jsRespondTo, respondTo, Theme } from '../../../styles/Theme';
import { IconSuggestion, IconSuggestionBox } from '../../components/Content/IconSuggestion';
import { Box, Divider, Tooltip } from '@mui/material';
import { SearchAssets } from '../../components/Search/SearchAssets';
import { StyledSnackbar } from '../../../styles/matieralui/Alerts';
import { StyledButton } from '../../../styles/matieralui/Button';
import { APIBase } from '../../../services/API';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import { StyledModal } from '../../../styles/matieralui/Modal';
import { BatchUpdater } from './BatchUpdater';
import { openToast } from '../../../redux/UI/ui.actions';
import { FullEngagements } from '../UserEngagement/redux/userengagement.selectors';
import { searchEngagements } from '../UserEngagement/redux/userengagement.actions';
import { ViewCreatorForm } from '../Views/ViewCreatorForm';
import { FullViews } from '../Views/redux/views.selectors';
import { push } from 'connected-react-router';

import moment from "moment";
import { FilterDateRange } from '../../components/Search/FilterDateRange';
import { FilterAssetType } from '../../components/Search/FilterAssetType';
import { SortBy } from '../../components/Search/SortBy';
import { FullUI } from '../../../redux/UI/ui.selectors';
import { Role } from '../../../redux/Auth/auth.selectors';
import { Limit } from '../../components/Search/Limit';
import { TotalCount } from '../../components/Search/TotalCount';
import { StyledDivider } from '../../../styles/matieralui/Divider';

const StyledBatchBar = styled(SmartContainer)`

    background-color: ${Theme.colors.secondary};
    border-radius: ${Theme.radius};
    color: ${Theme.colors.secondaryText};
    border: ${Theme.borderWidth} solid currentColor;
    padding-left: 1em;
    padding-right: 1em;
    .MuiButtonBase-root {
        color: currentColor;
    }
`

const StyledControlBar = styled(HorizontalStack)`
${respondTo('mobile', css`
    flex-wrap: wrap;
    [data-limit-select]{
        width:100%;
        max-width: 100%;
        margin-right: 0 !important;
        margin-bottom: 1em;
    }

`)}
`

const resolveGridSpanLength = (element) => {
    const span = {
        column: 1,
        row: 1
    };
    let width, height;

    switch(element.nodeName) {
        case 'IMG':
            width = element.naturalWidth;
            height = element.naturalHeight;
            break;
        case 'VIDEO':
            width = element.videoWidth;
            height = element.videoHeight; 
            break;
        default:
            width = 1;
            height = 1;
    }
    
    if(
        width >= (height * 1.5) &&
        width < (height * 2.25)
    ) {
        span.column = 2;
    }
    
    if (width >= (height * 2.25)) {
        span.column = 3;
    }

    if(height >= (width * 2)) {
        span.row = 2;
    }

    return span;
}

export const StyledAssetWrap = styled(SmartContainer)`
    // Custom Look for Portrait vs Landscape Sizes.

    [data-grid-item]{
        
        padding: 0.25em;
        > * {
            /* border: 1px solid rgba(0,0,0,0.15); */
            /* border: ${Theme.borderWidth} solid currentColor; */
            border: 1px solid rgba(0,0,0,0.0);
            transition: ${Theme.transition.one};
            transform: translate3d(0,0,0);
            box-shadow: ${Theme.shadow.none};
            &:hover {
                border: 1px solid rgba(0,0,0,1);
                box-shadow: ${Theme.shadow.two};
                transform: translate3d(-5px,-5px,0);
            }

            /* background: rgba(255,255,255,0.25); */
            display: flex;
            align-items: center;
            border-radius: ${Theme.radius};
            div {
                height: 100%;
            }
            div[data-asset-controls]{ height: auto; }
        }
        [type="image"],
        [type="video"]{
            display: flex;
            align-items: center;
            /* max-height: 190px; */
            overflow: hidden;

            img, video {
                border-radius: 0;
            }
        }
    }
`


export const AssetsList = ({
    onSelect,
    limit = 20,
    filters = null,
    myRole,
    hideControls = false,
    sortByKey = null,
    filterByDateKey = null,
    filterByTypeKey = null,
    lockFilters = false,
}) => {

    // New Modal
    const defaultCompare = 'AND'
    const dispatch = useDispatch();
    const [view, setView] = useState('all');
    const store = FullAssets();
    const storeTags = FullGenericTags();
    const storeLocations = FullLocations();
    const storePeople = FullPeople();
    const [tags, setTags] = useState(null);
    const [people, setPeople] = useState(null);
    const [locations, setLocations] = useState(null);
    const [extraFilters, setExtraFilters] = useState(filters);
    const [qsRead, setQsRead] = useState(false);
    const [grid, setGrid] = useState(true);
    const [selected, setSelected] = useState({});
    const [enableMultiSelect, setEnableMultiSelect] = useState(false);
    const [openBatchUpdate, setOpenBatchUpdate] = useState(false);
    const [openViewCreator, setOpenViewCreator] = useState(false);

    const [extraCustomFilters, setExtraCustomFilters] = useState(0)
    const [sortBy, setSortBy] = useState({ column: 'capturedDate', direction: 'DESC' });
    const [dateRange, setDateRange] = useState(null);
    const [limitControl, setLimitControl] = useState(limit);
    const assetTypeOptions = ['image', 'video']//, 'audio']
    const [assetTypes, setAssetTypes] = useState([...assetTypeOptions]);

    // Prefetch Interactions
    // const storeEngagements = FullEngagements();
    const storeViews = FullViews();
    const ui = FullUI();
    const currentUserRole = Role();

    // Rerender on Resize
    const windowSize = useWindowSize();

    // Store Key
    const storeKey = 'fulldataset';



    // New Search Options
    const [search, setSearch] = useState([]);

    const handleSearchChange = (obj) => {

        const arr = obj.tags;

        // Search Search
        setSearch(obj);

        // Apply Filters
        const searchFilters = { ...extraFilters };

        // Tags
        let tags = [];
        const fTags = arr.map(i => { if (i?.type === 'tag') tags.push(i.id); });
        searchFilters.GenericTag = JSON.stringify(tags);
        searchFilters.GenericTagCompare = defaultCompare;
        if (obj.GenericTagCompare) searchFilters.GenericTagCompare = obj.GenericTagCompare;
        if (tags?.length <= 0) {
            delete searchFilters.GenericTag;
            delete searchFilters.GenericTagCompare;
        }

        // Locations
        let locations = [];
        const fLocation = arr.map(i => { if (i?.type === 'location') locations.push(i.id); });
        searchFilters.Location = JSON.stringify(locations);
        searchFilters.LocationCompare = defaultCompare;
        if (obj.LocationCompare) searchFilters.LocationCompare = obj.LocationCompare;
        if (locations?.length <= 0) {
            delete searchFilters.Location;
            delete searchFilters.LocationCompare;
        }

        // People
        let people = [];
        const fPeople = arr.map(i => { if (i?.type === 'person') people.push(i.id); });
        searchFilters.Person = JSON.stringify(people);
        searchFilters.PersonCompare = defaultCompare;
        if (obj.PersonCompare) searchFilters.PersonCompare = obj.PersonCompare;
        if (people?.length <= 0) {
            delete searchFilters.Person;
            delete searchFilters.PersonCompare;
        }


        // Newest Change
        // If LockFilters === true then this is probably a single tag/person/location view.
        // We need to ensure that filter stays on no matter what.
        if (lockFilters === true) {
            const lockedFilters = { ...searchFilters, ...filters };
            setExtraFilters(lockedFilters);
        } else {
            // Set The Filters
            setExtraFilters(searchFilters);
        }


    }
    const handleLimitChange = (v) => {
        setLimitControl(parseInt(v));
    }

    useEffect(() => {
        // Load The Options
        if (!storeTags[storeKey]) dispatch(searchGenericTags(0, null, null, 'all', { prefix: storeKey }))
        if (!storeLocations[storeKey]) dispatch(searchLocations(0, null, null, 'all', { prefix: storeKey }))
        if (!storePeople[storeKey]) dispatch(searchPeople(0, null, null, 'all', { prefix: storeKey }))

        // Set Default Sort
        if (sortByKey && ui[sortByKey]) setSortBy(ui[sortByKey]);
        if (filterByDateKey && ui[filterByDateKey]) setDateRange(ui[filterByDateKey]);
        if (filterByTypeKey && ui[filterByTypeKey]) setAssetTypes(ui[filterByTypeKey]);

    }, [])

    useEffect(() => {
        if (store?.downloadSuccess) {
            if (store?.download?.key) {
                const hostedPath = mediaPath(store?.download?.key, store?.download?.storage);
                setTimeout(() => { window.open(hostedPath); }, 500)
            }
            // const pathToFile = `${APIBase}/${store.download.path}`;
            // const p = pathToFile.split('.zip');
            // const path = p[0];
            // setTimeout(() => { window.open(path); }, [500])
        }
    }, [store?.downloadLoading])

    useEffect(() => {
        if (storeViews.createSuccess) {
            setOpenViewCreator(false);
            dispatch(push('/views/' + storeViews?.create?.id))
        }
    }, [storeViews?.createLoading])

    // --------------------------
    // Interactions
    // --------------------------

    const openViewEditor = () => {
        setOpenViewCreator(true);
    }

    // On Select
    const handleSelect = (item) => {
        if (enableMultiSelect !== true) {
            onSelect(item);
        } else {
            const s = formatSelected(item);
            setSelected(s);
        }

    }

    const formatSelected = (item) => {

        const s = { ...selected }
        const total = Object.keys(s)?.length;
        // SHIFT CLICK
        if (total > 0 && shift === true && store?.items?.rows?.length > 0) {
            // Get Last Selected
            const lastSelectedKey = Object.keys(s)[total - 1];
            const thisKey = item.id;
            if (s[lastSelectedKey]) {

                let enabled = 'ready';

                const shiftSelected = store.items.rows.filter(ass => {

                    if ((ass.id === thisKey || ass.id === lastSelectedKey) && enabled === 'ready') {
                        enabled = 'active';
                        if (!s[ass.id]) s[ass.id] = { ...ass };
                    } else if ((ass.id === thisKey || ass.id === lastSelectedKey) && enabled === 'active') {
                        if (!s[ass.id]) s[ass.id] = { ...ass };
                        enabled = 'done';
                    } else if (enabled === 'active') {
                        if (!s[ass.id]) s[ass.id] = { ...ass };
                    }

                })
            }

        } else {
            // One At A Time
            if (!s[item.id]) s[item.id] = { ...item };
            else delete s[item.id];
        }
        return s;
    }

    const cmd = useKeyPress("Meta");
    const ctrl = useKeyPress("Control");
    const escape = useKeyPress("Escape");
    const shift = useKeyPress("Shift")

    useEffect(() => {
        // Clear & Close Editor
        setSelected({});
        setEnableMultiSelect(false);
    }, [escape])

    const toggleMultiSelect = () => {
        setSelected({});
        setEnableMultiSelect(!enableMultiSelect);
    }

    const handleControlClick = (item) => {

        // Open Edit Mode If Not Open Already
        if (enableMultiSelect !== true) {
            setEnableMultiSelect(true);
            const s = formatSelected(item);
            setSelected(s);
        } else {
            handleSelect(item);
        }

    }

    const editSinglePhoto = (item) => {

        // Set the Selected Asset
        handleControlClick(item);

        // Open the Batch Editor
        setOpenBatchUpdate('edit');

    }

    const handleClearSelection = () => {
        setSelected({});
    }

    const handleBatchEdit = () => {
        setOpenBatchUpdate('edit');
    }
    const handleBatchDelete = () => {
        setOpenBatchUpdate('delete');
    }

    const handleBatchDownload = () => {
        dispatch(batchDownload(selected))
    }

    const handleBatchUpdate = (args) => {
        dispatch(openToast("Batch Update Complete", "success"));
        setOpenBatchUpdate(false);
    }


    const runRefresh = () => {
        if (window?.location) window.location.reload();
    }


    const renderEmpty = () => {

        return (
            <EmptyMessage title="Empty">
                <StyledP>No <StyledB italics>photos</StyledB> have been match these filters yet. Upload to a {TERM_LIBRARY} to begin.</StyledP>
            </EmptyMessage>
        )
    }

    const renderMediaCard = (item, onClickItem, setGridSpan) => {

        const s = (selected[item.id]) ? true : false;

        const handleAssetClick = (x) => {

            if (cmd === true || ctrl === true) {
                handleControlClick(x);
            } else {
                onClickItem(x);
            }

        }
        
        const onMediaLoad = (event) => {
            if(!setGridSpan) return;

            const img = event.target;
            const spanLength = resolveGridSpanLength(img);
            setGridSpan(spanLength);
        }

        const showEdit = (currentUserRole !== 'owner' && currentUserRole !== 'admin') ? false : true;
        return (
            <AssetCard
                display="feed"
                selected={s}
                enableSelect={enableMultiSelect}
                item={item}
                onClick={handleAssetClick}
                crop={ImageCroppingPresets.preview}
                showEdit={showEdit}
                onEditClick={editSinglePhoto}
                onMediaLoad={onMediaLoad}
            />
        )
    }

    const formatTagApplication = (terms, key) => {
        // TODO: Will need to update to new search format
        const filters = { ...extraFilters }
        const formattedTag = JSON.stringify(terms.map(i => i.id));
        filters[key] = formattedTag;
        if (terms?.length <= 0) delete filters[key];
        setExtraFilters(filters)
    }


    const handleGenericTagChange = (tags) => {
        setTags(tags);
        formatTagApplication(tags, 'GenericTag')
    }
    const handleLocationsChange = (tags) => {
        setLocations(tags);
        formatTagApplication(tags, 'Location')
    }
    const handlePeopleChange = (tags) => {
        setPeople(tags);
        formatTagApplication(tags, 'Person')
    }

    const formatQSTax = (key) => {
        const val = getQueryParam(key);
        if (!val) return;
        const clean = JSON.parse(val);
        return clean.map(id => ({ id: id }))

    }

    const reset = () => {

        const qsTags = formatQSTax('GenericTag');
        const qsLocations = formatQSTax('Location');
        const qsPeople = formatQSTax('Person');

        const qTags = (qsTags) ? qsTags : [];
        const qLocations = (qsLocations) ? qsLocations : [];
        const qPeople = (qsPeople) ? qsPeople : [];


        // New Way with QueryString
        setTags(qTags)
        setLocations(qLocations)
        setPeople(qPeople);
        setQsRead(true);

        // Compare

        const qsLocationCompare = getQueryParam('LocationCompare');
        const qsPersonCompare = getQueryParam('PersonCompare');

        const filters = { ...extraFilters }

        // Tags
        if (!filters?.GenericTag) {
            const qsTagsFormated = qTags.map(i => i.id)
            const formattedTag = JSON.stringify(qsTagsFormated);
            filters.GenericTag = formattedTag;
            if (qTags?.length <= 0) delete filters.GenericTag;
        }
        // Location
        if (!filters?.Location) {
            const formattedLocations = JSON.stringify(qLocations.map(i => i.id));
            filters.Location = formattedLocations;
            if (qLocations?.length <= 0) delete filters.Location;
        }
        // People
        if (!filters?.Person) {
            const formattedPerson = JSON.stringify(qPeople.map(i => i.id));
            filters.Person = formattedPerson;
            if (qPeople?.length <= 0) delete filters.Person;
        }

        // Compare: Tags
        if (!filters?.GenericTagCompare) {
            const compare = getQueryParam('GenericTagCompare');
            filters.GenericTagCompare = compare;
            if (qTags?.length <= 0) delete filters.GenericTagCompare;
        }

        // Compare: Location
        if (!filters?.LocationCompare) {
            const compare = getQueryParam('LocationCompare');
            filters.LocationCompare = compare;
            if (qLocations?.length <= 0) delete filters.LocationCompare;
        }

        // Compare: People
        if (!filters?.PersonCompare) {
            const compare = getQueryParam('PersonCompare');
            filters.PersonCompare = compare;
            if (qPeople?.length <= 0) delete filters.PersonCompare;
        }

        setExtraFilters(filters);

        // Set Initial Search
        let initialSearch = [];
        if (qTags.length) initialSearch = [...initialSearch, ...qTags];
        if (qLocations.length) initialSearch = [...initialSearch, ...qLocations];
        if (qPeople.length) initialSearch = [...initialSearch, ...qPeople];

        // Search Args
        const searchArgs = {};
        searchArgs.tags = initialSearch;
        if (filters?.GenericTagCompare) searchArgs.GenericTagCompare = filters.GenericTagCompare;
        if (filters?.LocationCompare) searchArgs.LocationCompare = filters.LocationCompare;
        if (filters?.PersonCompare) searchArgs.PersonCompare = filters.PersonCompare;
        setSearch(searchArgs)

    }

    useEffect(() => {
        reset();
    }, [filters])

    useEffect(() => {


        // Don't Alter the Querystring Until we have read from it.
        if (!qsRead) return;

        // -------
        // IDS
        // -------

        // Manually Set & Remove Query Params
        if (extraFilters?.GenericTag && !filters?.GenericTag) setQueryParam('GenericTag', extraFilters.GenericTag);
        else removeQueryParam('GenericTag');

        if (extraFilters?.Location && !filters?.Location) setQueryParam('Location', extraFilters.Location);
        else removeQueryParam('Location');

        if (extraFilters?.Person && !filters?.Person) setQueryParam('Person', extraFilters.Person);
        else removeQueryParam('Person');

        // -------
        // COMPARES
        // -------

        if (extraFilters?.GenericTagCompare && !filters?.GenericTagCompare) setQueryParam('GenericTagCompare', extraFilters.GenericTagCompare);
        else removeQueryParam('GenericTagCompare');

        if (extraFilters?.LocationCompare && !filters?.LocationCompare) setQueryParam('LocationCompare', extraFilters.LocationCompare);
        else removeQueryParam('LocationCompare');

        if (extraFilters?.PersonCompare && !filters?.PersonCompare) setQueryParam('PersonCompare', extraFilters.PersonCompare);
        else removeQueryParam('PersonCompare');


    }, [extraFilters])

    const handleCombinedFilterClick = (tags) => {

        if (!qsRead) return;

        let ts = [];
        let ls = [];
        let ps = [];
        const whatever = tags?.map(item => {
            if (item.type === 'location') ls.push(item);
            else if (item.type === 'tag') ts.push(item);
            else if (item.type === 'person') ps.push(item);
        });

        const fs = { ...extraFilters }
        // // Tags
        setTags(ts);
        const formattedTag = JSON.stringify(ts.map(i => i.id));
        fs.GenericTag = formattedTag;
        if (ts?.length <= 0) delete fs.GenericTag;
        // // Location
        setLocations(ls);
        const formattedLocations = JSON.stringify(ls.map(i => i.id));
        fs.Location = formattedLocations;
        if (ls?.length <= 0) delete fs.Location;
        // // People
        setPeople(ps);
        const formattedPerson = JSON.stringify(ps.map(i => i.id));
        fs.Person = formattedPerson;
        if (ps?.length <= 0) delete fs.Person;

        setExtraFilters(fs)
    }


    const renderCombinedOption = (props, option) => {
        let icon = (<IconTag />)
        if (option.type === 'location') icon = (<IconLocation />)
        else if (option.type === 'person') icon = (<IconPerson />)
        return (<IconSuggestionBox icon={icon} label={option.name} {...props} />)
    }


    const sortByRange = (x) => {
        setSortBy(x);
        setExtraCustomFilters(+1)
    };

    const sortDateRange = (v) => {
        setDateRange(v);
        setExtraCustomFilters(+1)
    };

    const renderCustomControls = () => {

        if (hideControls === true) return (
            <HorizontalStack flex align="center" justify="flex-end" width="100%">
                <SmartContainer>
                    <StyledIconButton onClick={() => runRefresh()}>
                        <IconRefresh />
                    </StyledIconButton>
                </SmartContainer>
                <SmartContainer>
                    <StyledIconButton onClick={() => setGrid(!grid)}>
                        {!grid && (<IconGrid />)}
                        {grid && (<IconFeed />)}
                    </StyledIconButton>
                </SmartContainer>
            </HorizontalStack>
        );

        const formattedTags = storeTags[storeKey]?.rows?.map(b => ({ type: 'tag', ...b }))
        const formattedLocations = storeLocations[storeKey]?.rows?.map(b => ({ type: 'location', ...b }))
        const formattedPeople = storePeople[storeKey]?.rows?.map(b => ({ type: 'person', ...b }))

        let combinedOptions = []
        if (formattedTags && !filters?.GenericTag) combinedOptions = [...combinedOptions, ...formattedTags]
        if (formattedLocations && !filters?.Location) combinedOptions = [...combinedOptions, ...formattedLocations]
        if (formattedPeople && !filters?.Person) combinedOptions = [...combinedOptions, ...formattedPeople]

        const totalItemsNum = store?.items?.count || 0;
        const itemsDisplayedNum = store?.items?.rows.length || 0;

        return (
            <Stack width="100%">


                <SearchAssets
                    filters={filters}
                    value={search}
                    options={combinedOptions}
                    onChange={handleSearchChange}
                    renderOption={renderCombinedOption}
                    inputLabel="Search by tags, people, locations..."
                    defaultCompare={defaultCompare}
                />
                <StyledControlBar flex align="center" justify="flex-end">
                    <TotalCount displayedCount={itemsDisplayedNum} totalCount={totalItemsNum} />
                    <Limit value={limitControl} onChange={handleLimitChange} />
                    <SortBy storageKey={sortByKey} options={['name', 'createdAt', 'capturedDate']} value={sortBy} onChange={sortByRange} />
                    <FilterDateRange storageKey={filterByDateKey} value={dateRange} onChange={(x) => sortDateRange(x)} />
                    <FilterAssetType storageKey={filterByTypeKey} options={assetTypeOptions} value={assetTypes} onChange={setAssetTypes} />

                    {myRole != 'viewer' && myRole != 'contributor' && myRole != 'editor' && (
                        <SmartContainer>
                            <Tooltip title="Create a Sharable View" placement="top">
                                <StyledIconButton onClick={openViewEditor}>
                                    <IconView />
                                </StyledIconButton>
                            </Tooltip>
                        </SmartContainer>
                    )}
                    {myRole != 'viewer' && (
                        <SmartContainer>
                            <Tooltip title="Batch Editing & Downloading" placement="top">
                                <StyledIconButton onClick={toggleMultiSelect}>
                                    {!enableMultiSelect && (<IconSelect />)}
                                    {enableMultiSelect && (<IconSelectClear />)}
                                </StyledIconButton>
                            </Tooltip>
                        </SmartContainer>
                    )}
                    <SmartContainer>
                        <Tooltip title="Refresh" placement="top">
                            <StyledIconButton onClick={() => runRefresh()}>
                                <IconRefresh />
                            </StyledIconButton>
                        </Tooltip>
                    </SmartContainer>
                    <SmartContainer>
                        <Tooltip title="Full Screen or Grid View" placement="top">
                            <StyledIconButton onClick={() => setGrid(!grid)}>
                                {!grid && (<IconGrid />)}
                                {grid && (<IconFeed />)}
                            </StyledIconButton>
                        </Tooltip>
                    </SmartContainer>
                </StyledControlBar>
            </Stack>
        )
    }

    if (!qsRead) return (
        <SmartContainer><StyledCircularProgress /></SmartContainer>
    )

    const getGridColumns = () => {
        // Single Column
        if (!grid) return 1;

        // Mobile
        const isMobile = jsRespondTo('mobile');
        if (isMobile) return 3;

        // Tablet
        const isTablet = jsRespondTo('tablet');
        if (isTablet) return 4;

        // Desktop
        const isDesktop = jsRespondTo('desktop');
        if (isDesktop) return 4;

        // Large
        const isLarge = jsRespondTo('large');
        if (isLarge) return 5;

        // XLarge
        const isXLarge = jsRespondTo('xlarge');
        if (isXLarge) return 6;

        // XXLarge
        const isXXLarge = jsRespondTo('2xlarge');
        if (isXXLarge) return 7;

        return 3;

    }

    // let cols = (grid) ? 3 : 1;
    // const isMobile = jsRespondTo('mobile');
    // if (isMobile && grid) cols = 2;
    let cols = getGridColumns();

    const formatOtherFilters = () => {

        // Clone Current Filters
        const x = { ...extraFilters };

        // Set Sort By Order
        if (sortBy?.column) x.order = `[["${sortBy.column}", "${sortBy.direction}"]]`;

        // Set Date Range
        if (dateRange?.start && dateRange?.end) x.daterange = `["${dateRange.start}", "${dateRange.end}"]`;
        else delete x.daterange;
        x.datecolumn = "capturedDate"

        // Set Asset Types
        if (assetTypes?.length && assetTypes.length < assetTypeOptions.length) {
            x.mediaType = JSON.stringify(assetTypes);
        }

        // Return Filters
        return x;
    };

    // Render Page 
    return (
        <StyledAssetWrap thinking={store?.downloadLoading}>
            <ModelList
                model="Asset"
                action={searchAssets}
                restore={restoreAsset}
                selector={FullAssets}
                onSelect={handleSelect}
                variant={grid ? "masonary" : "cards"}
                defaultLimit={limitControl}
                emptyRenderer={renderEmpty}
                filters={formatOtherFilters()}
                customRenderer={renderMediaCard}
                paginationControls={renderCustomControls}
                hideSearch={true}
                infiniteScroll={true}
                columns={cols}
                forceLayout={true}
                forceDelete={forceDeleteAsset}
            />

            {enableMultiSelect && Object.keys(selected).length > 0 && !openBatchUpdate && (
                <StyledSnackbar open={true} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} color="primary">
                    <StyledBatchBar flex align="center">
                        <StyledP>{Object.keys(selected).length} Items</StyledP>
                        &nbsp;&nbsp;&nbsp;
                        {store?.downloadLoading === true && (
                            <SmartContainer flex align="center" padding={2}>
                                <StyledP>Zipping &amp; Downloading...</StyledP>
                                &nbsp;&nbsp;&nbsp;
                                <StyledCircularProgress color="base" size="small" />
                            </SmartContainer>

                        )}
                        &nbsp;&nbsp;&nbsp;
                        {store?.downloadLoading !== true && (
                            <SmartContainer flex>
                                <Tooltip title="Batch Update Tags" placement="top"><StyledIconButton onClick={handleBatchEdit}><IconEdit /></StyledIconButton></Tooltip>
                                <Tooltip title="Zip & Download" placement="top"><StyledIconButton onClick={handleBatchDownload}><IconDownload /></StyledIconButton></Tooltip>
                                <Tooltip title="Delete Select" placement="top"><StyledIconButton onClick={handleBatchDelete}><IconTrash /></StyledIconButton></Tooltip>
                                <Tooltip title="Clear Selected" placement="top"><StyledIconButton onClick={handleClearSelection}><IconSelectClear /></StyledIconButton></Tooltip>
                                <Tooltip title="Exit" placement="top"><StyledIconButton onClick={toggleMultiSelect}><IconX /></StyledIconButton></Tooltip>
                            </SmartContainer>
                        )}
                    </StyledBatchBar>
                </StyledSnackbar>
            )}
            <StyledModal open={openBatchUpdate} onClose={() => setOpenBatchUpdate(false)} label={(openBatchUpdate === 'delete') ? 'Batch Delete' : 'Batch Update'}>
                <BatchUpdater action={openBatchUpdate} assets={selected} myRole={myRole} onCancel={() => setOpenBatchUpdate(false)} onComplete={handleBatchUpdate} />
            </StyledModal>
            <StyledModal open={openViewCreator} onClose={() => setOpenViewCreator(false)} label="Save View">
                <ViewCreatorForm filters={extraFilters} />
            </StyledModal>
        </StyledAssetWrap>
    )
}